import * as React from "react"
import { useEffect } from "react"

import {ADMIN_ROUTES} from "@constants"
import PageWrapper from "../../@PageWrapper"
import {UserActivitiesIsEmpty, resetUserActivityTabs} from "./@signals";
import AdminUserActivitiesFilters from './Filters'
import UserActivityContent from "./Content";


export default function AdminUserActivitiesPage() {

    useEffect(() => {
        return resetUserActivityTabs
    }, [])

    return <PageWrapper
        head={`${ADMIN_ROUTES.TITLE} | ${ADMIN_ROUTES.USER_ACTIVITIES_TITLE}`}
        title={ADMIN_ROUTES.USER_ACTIVITIES_TITLE}
        isEmpty={UserActivitiesIsEmpty.value}
        filters={<AdminUserActivitiesFilters/>}
    >
        <UserActivityContent />
    </PageWrapper>
}